import { useState, useEffect, useMemo } from "react";
// theme files

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Route, Routes } from "react-router-dom";
import Proposals from "./pages/Proposals";
import Vote from "./pages/Vote";
import Dashboard from "./pages/Dashboard";
import Home from "./pages/Home";
import Members2 from "./pages/Members2";
import Members from "./pages/Members";
import Communities from "./pages/Communities";
import Graduation from "./pages/Graduation";
import Contact from "./pages/Contact";
import GraduationResults from "./pages/GraduationResults";
import MyCommunity from "./pages/MyCommunity";
import CommunityTemplate from "./pages/communities/CommunityTemplate";
import Join from "./pages/Join";
import Login from "./pages/Login";
import ProposalTemplate from "./pages/ProposalTemplate";
import Proposal from "./pages/Proposal";
import CreateProposal from "./pages/CreateProposal";
import CreateCommunity from "./pages/CreateCommunity";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
// Theme CSS files
import "./styles/main.css";
import ReactGA from "react-ga";

// Contexts
import { UserProvider } from "./functions/UserContext";

const App = () => {
  useEffect(() => {
    ReactGA.initialize("G-NF6PRHWV7M");
    // To Report Page View
    ReactGA.pageview(window.location.pathname + window.location.search);
    // fetchAPI();
  }, []);

  // const fetchAPI = async () => {
  //   const response = await axios.get("http://localhost:3000/api");
  //   console.log(response.data);
  // };

  return (
    <div className="">
      <UserProvider>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/Vote" element={<Vote />} />
          <Route path="/Members" element={<Members />} />
          <Route path="/Communities" element={<Communities />} />
          <Route path="/MyCommunity" element={<MyCommunity />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/Join" element={<Join />} />

          <Route path="/:community/:id" element={<Proposal />} />
          <Route path="/CreateProposal" element={<CreateProposal />} />
          <Route path="/CreateCommunity" element={<CreateCommunity />} />
          <Route path="/Proposal-Template" element={<ProposalTemplate />} />
          <Route path="/dashboard/members/:community" element={<Members2 />} />
          <Route
            path="/dashboard/proposals/:community"
            element={<Proposals />}
          />

          {/* <Route path="/Legacy Park-Community" element={<LegacyPark />} /> */}
          <Route path="/:community" element={<CommunityTemplate />} />
          <Route path="/graduation-results" element={<GraduationResults />} />
          <Route path="/graduation" element={<Graduation />} />
        </Routes>
        <Footer />
      </UserProvider>
    </div>
  );
};

export default App;
